export default __webpack_public_path__ + "static/media/aam-new-logo-3.d3da8f62.png";